import { map, catchError } from 'rxjs/operators';
import { Observable, of, Subscription } from 'rxjs';
import { Injectable, OnDestroy } from '@angular/core';

import { UserHTTPService } from './http';

import { BaseLookupModel } from '../../models';
@Injectable({
   providedIn: 'root',
})
export class AuthLookupService implements OnDestroy {
   // private readonly fields
   private readonly unsubscribe: Subscription[] = [];

   constructor(private readonly userHTTPSService: UserHTTPService) { }

   // public methods
   UsersLookUp(text: string, companyId: number, branchId: number): Observable<BaseLookupModel[]> {
      return this.userHTTPSService.Lookup(text, companyId, branchId).pipe(
         map((result: BaseLookupModel[]) => result),
         catchError((err) => {
            console.error('User Search error:', err);
            return of([]);
         })
      );
   }

   // private methods
   ngOnDestroy() {
      this.unsubscribe.forEach((sb) => sb.unsubscribe());
   }
}
